/* eslint-disable jsx-a11y/media-has-caption */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { getAuthSession } from "../common";
import { useSelector } from "react-redux";
import { _callDocUpdate } from "../../../SocketIo";
import { PauseIcon, PlayIcon } from "../../../assets/icons/svg";

const SharedFileData = () => {
  const { user_unique_key } = getAuthSession();
  const { call } = useSelector((state) => state);

  const { callDetail, sharedFileData } = call || {};

  const showControls =
    user_unique_key === sharedFileData?.user_id ? true : false;

  const manageMediaControls = (e) => {
    e.preventDefault();
    const updatedCallDetail = { ...callDetail };
    const updatedSharedFile = { ...updatedCallDetail["sharedFile"] };
    updatedSharedFile["play"] = !callDetail["sharedFile"].play;
    updatedCallDetail["sharedFile"] = updatedSharedFile;
    _callDocUpdate(updatedCallDetail);
  };

  return (
    <>
      {sharedFileData?.fileType === "audio" ? (
        <>
          {showControls && (
            <a
              href={void 0}
              onClick={manageMediaControls}
              className="icon__tag bg-white d-flex align-items-center justify-content-center icon_container index-3 mr-2 position-absolute icon-pause"
            >
              {sharedFileData?.play ? (
                <PauseIcon width={12} height={12} />
              ) : (
                <PlayIcon width={12} height={12} />
              )}
            </a>
          )}

          <audio id="audioPlayer" width="100%" height="100%"></audio>
          <div className="d-flex flex-column align-items-center justify-content-center audio-file text-sm position-absolute audio-img-container text-white">
            <img
              src="assets/images/music-file.png"
              className="audio-img"
              alt="audio-img"
            />
            Audio is playing...
          </div>
        </>
      ) : (
        <>
          {showControls && (
            <a
              href={void 0}
              onClick={manageMediaControls}
              className="icon__tag bg-white d-flex align-items-center justify-content-center icon_container index-3 mr-2 position-absolute icon-pause"
            >
              {sharedFileData?.play ? (
                <PauseIcon width={12} height={12} />
              ) : (
                <PlayIcon width={12} height={12} />
              )}
            </a>
          )}

          <video id="videoPlayer" width="100%" height="100%"></video>
        </>
      )}
    </>
  );
};

export default SharedFileData;
